import { Heading } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { DatevAuthCard } from './DatevAuthCard';

export function AuthContainer() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <Heading>{t('domain.datev.page.connection.title')}</Heading>
      <DatevAuthCard />
    </div>
  );
}
